import { Loading } from '@octano/global-ui';
import { createContext, useEffect, useState } from 'react';

import { useParameters } from '../hooks/useParameters';
import { ParametersContextType } from '../types/parametersTypes';

export const ParametersContext = createContext({} as ParametersContextType);

const ParametersLoaderProvider = (props: any) => {
  const {
    loadRoles,
    loadCountries,
    loadDefaultCountry,
    loadIdentificationTypes,
    loadRegionsAndCommunes,
    loadInstitutionTypes,
    loadCourseTypes,
  } = useParameters();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([
      loadRoles(),
      loadCountries(),
      loadDefaultCountry(),
      loadIdentificationTypes(),
      loadRegionsAndCommunes(),
      loadInstitutionTypes(),
      loadCourseTypes(),
    ]).then(() => {
      setLoading(false);
    });
  }, [
    loadRoles,
    loadCountries,
    loadDefaultCountry,
    loadIdentificationTypes,
    loadRegionsAndCommunes,
    loadInstitutionTypes,
    loadCourseTypes,
  ]);
  if (loading) {
    return (
      <div className="text-center">
        <Loading textBody="" className="m-auto" />
      </div>
    );
  }
  return props.children;
};

export default ParametersLoaderProvider;
